import { memo, useCallback } from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { StepTypeEditorProps } from "../types";

type AmlbotFormat = NonNullable<
  NonNullable<StepTypeEditorProps["step"]["amlbot"]>["format"]
>;

export const IdentificationStepTypeSpecificProps = memo(
  ({ step, onChange }: StepTypeEditorProps) => {
    const handleFormatChange = useCallback(
      (format: AmlbotFormat) => {
        onChange({
          ...step,
          amlbot: {
            ...step.amlbot,
            format,
          },
        });
      },
      [onChange, step],
    );

    return (
      <Stack spacing={0} sx={{ pt: 0.5, maxWidth: 360 }}>
        <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 1 }}>
          AMLBot Settings
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mb: 1.5 }}>
          Only used when the top-level identification provider is AMLBot.
        </Typography>
        <TextField
          select
          SelectProps={{ native: true }}
          label='Format'
          size='small'
          fullWidth
          value={step.amlbot?.format ?? "default"}
          onChange={(e) => handleFormatChange(e.target.value as AmlbotFormat)}
        >
          <option value='default'>default</option>
          <option value='doc_only'>doc_only</option>
        </TextField>
      </Stack>
    );
  },
);
